/**
 * LEANA FIT — Animations & Interactions
 * IntersectionObserver · Counter · Smooth scroll · 3D card hover
 */
(function () {
  'use strict';

  /* ── Fade-up on scroll ───────────────────── */
  var fadeEls = document.querySelectorAll('.fade-up');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    var fadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach(function (el) {
      fadeObserver.observe(el);
    });
  } else {
    // Fallback: show everything
    fadeEls.forEach(function (el) {
      el.classList.add('visible');
    });
  }

  /* ── Animated counters ───────────────────── */
  var counters = document.querySelectorAll('.lf-counter');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (el) {
      counterObserver.observe(el);
    });
  }

  function animateCounter(el) {
    var target = el.getAttribute('data-target') || el.textContent;
    var numMatch = target.match(/[\d,.]+/);
    if (!numMatch) return;

    var rawNum = numMatch[0].replace(/,/g, '');
    var endVal = parseFloat(rawNum);
    if (isNaN(endVal)) return;

    var prefix = target.substring(0, target.indexOf(numMatch[0]));
    var suffix = target.substring(target.indexOf(numMatch[0]) + numMatch[0].length);
    var hasDecimal = rawNum.indexOf('.') !== -1;
    var duration = 1500;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // ease-out
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * endVal;
      if (hasDecimal) {
        el.textContent = prefix + current.toFixed(1) + suffix;
      } else {
        var formatted = Math.floor(current).toLocaleString('fr-FR');
        el.textContent = prefix + formatted + suffix;
      }
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target;
      }
    }

    requestAnimationFrame(step);
  }

  /* ── Smooth scroll for anchor links ──────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var targetEl = document.querySelector(targetId);
      if (targetEl) {
        e.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Subtle 3D tilt on product cards ─────── */
  var cards = document.querySelectorAll('.lf-product-card');
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var centerX = rect.width / 2;
      var centerY = rect.height / 2;
      var rotateX = ((y - centerY) / centerY) * -3;
      var rotateY = ((x - centerX) / centerX) * 3;
      card.style.transform =
        'translateY(-8px) perspective(800px) rotateX(' +
        rotateX +
        'deg) rotateY(' +
        rotateY +
        'deg)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });

  /* ── Pause marquee on hover ──────────────── */
  var trustBar = document.querySelector('.lf-trust-bar');
  if (trustBar) {
    var track = trustBar.querySelector('.lf-trust-bar__track');
    if (track) {
      trustBar.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      trustBar.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    }
  }
})();
